import React from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import DeleteExtraction from './DeleteExtraction';

class ExtractionSettings extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
        };
    }
    render() {
        return (
            <>
                <ReactBootstrap.Container> 
                    <ReactBootstrap.Row>
                        <ReactBootstrap.Col md={6}>
                            <ReactBootstrap.Container>
                                <ReactBootstrap.Row>
                                    <ReactBootstrap.Col md={1} style={{ "height": 10 }}>
                                    </ReactBootstrap.Col>
                                </ReactBootstrap.Row>
                                <ReactBootstrap.Row>
                                    <ReactBootstrap.Col md={12}>
                                        Extraction Name: {this.props.currentExtraction?.name}
                                    </ReactBootstrap.Col>
                                </ReactBootstrap.Row>
                            </ReactBootstrap.Container>
                        </ReactBootstrap.Col>
                    </ReactBootstrap.Row>
                    <ReactBootstrap.Row>
                        <div className="col">
                            &nbsp;
                        </div>
                        <div className="col-md-2 text-end" style={{ padding:0 }}>
                            <DeleteExtraction
                            onDelete={() => this.props.onExtractionDelete(this.props.currentExtraction?.id)}
                            extractionName={this.props.currentExtraction?.name}
                            />
                        </div>
                    </ReactBootstrap.Row>
                </ReactBootstrap.Container>
            </>
        );
    }
}

export default ExtractionSettings;